<div class="notifications-popover">
  <div class="notifications-popover-header">
    <span class="notifications-popover-title">Ειδοποιήσεις</span>
  </div>
  <div class="notifications-popover-body">
    <div *ngIf="loading" class="notifications-loading">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Φόρτωση...</span>
    </div>
    <ng-container *ngIf="!loading">
      <div *ngIf="totalRecords === 0" class="notifications-empty">Δεν υπάρχουν ειδοποιήσεις</div>
      <div *ngIf="totalRecords > 0" class="notifications-list-wrapper">
        <div class="notifications-list">
          <button
            *ngFor="let notification of notifications"
            type="button"
            class="notification-item"
            [class.notification-item--read]="isDelivered(notification)"
            (click)="onNotificationClick(notification)"
          >
            <div class="notification-item-title">{{ notification.title }}</div>
            <div class="notification-item-body">{{ notification.body }}</div>
            <div class="notification-item-date">{{ formatDate(notification.createdAt) }}</div>
          </button>
        </div>
        <div *ngIf="loadingPage" class="notifications-list-loading-overlay" aria-hidden="true">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
      </div>
    </ng-container>
    <p-paginator
      *ngIf="!loading && totalRecords > 0"
      [first]="first"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [pageLinkSize]="1"
      [showPageLinks]="false"
      [showCurrentPageReport]="false"
      (onPageChange)="onPageChange($event)"
      styleClass="notifications-paginator"
    ></p-paginator>
  </div>
</div>
